/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SuggestionResultItem { 
    entity_id: string;
    display_name: string;
    image_url?: string;
    score?: number;
    /**
     * Map: field name -> list of highlighted fragments for that field. Keys are field names (e.g., \"title\", \"body\"). 
     */
    highlight?: { [key: string]: Array<string>; };
}